var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "facet-placeholder" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "ui button search-button",
        staticStyle: { width: "97%", margin: "5px" },
        on: {
          click: function($event) {
            return _vm.searchObservationsButtonClick($event)
          }
        }
      },
      [_vm._v("\n      Search For Observations\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui segment",
        staticStyle: { margin: "5px", padding: "8px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "ui top attached label",
            staticStyle: { padding: "8px" }
          },
          [_vm._v("Producer")]
        ),
        _vm._v(" "),
        _vm.getFacetClassification != null
          ? _c(
              "div",
              [
                _c("facet-component", {
                  staticStyle: {
                    resize: "vertical",
                    "overflow-y": "scroll",
                    "min-height": "18px",
                    height: "90px"
                  },
                  attrs: {
                    facetElements: _vm.getFacetClassification.producerNames,
                    mutationName: "UPDATE_FILTERS_PRODUCER_NAMES"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui segment",
        staticStyle: { margin: "5px", padding: "8px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "ui top attached label",
            staticStyle: { padding: "8px" }
          },
          [_vm._v("Variable Names")]
        ),
        _vm._v(" "),
        _vm.getFacetClassification != null
          ? _c(
              "div",
              [
                _c("facet-component", {
                  staticStyle: {
                    resize: "vertical",
                    "overflow-y": "scroll",
                    "min-height": "18px",
                    height: "100px"
                  },
                  attrs: {
                    facetElements:
                      _vm.getFacetClassification.variableNamesFacet,
                    mutationName: "UPDATE_FILTERS_VARIABLE_NAMES"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui segment",
        staticStyle: { margin: "5px", padding: "8px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "ui top attached label",
            staticStyle: { padding: "8px" }
          },
          [_vm._v("Observed Property - Scientific Keyword Tags")]
        ),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "trajectories-text",
              staticStyle: { float: "left", width: "70px" }
            },
            [_vm._v("Match type:")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticStyle: { "font-size": "11px", "margin-bottom": "2px" },
              on: {
                change: function($event) {
                  return _vm.linkTypeChanged($event)
                }
              }
            },
            [
              _c("option", { attrs: { value: "direct_tags" } }, [
                _vm._v("Directly tagged keywords")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "follow_links" } }, [
                _vm._v("All linked keywords")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } }, [
          _c(
            "div",
            {
              staticClass: "trajectories-text",
              staticStyle: { float: "left", width: "70px" }
            },
            [_vm._v("Onotolgy:")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticStyle: { "font-size": "11px", "margin-bottom": "2px" },
              on: {
                change: function($event) {
                  return _vm.ontologyChanged($event)
                }
              }
            },
            [
              _c("option", { attrs: { value: "None" } }, [_vm._v("None")]),
              _vm._v(" "),
              _c(
                "option",
                { attrs: { value: "http://vocabs.lter-europe.net/EnvThes" } },
                [_vm._v("EnvThes")]
              ),
              _vm._v(" "),
              _c(
                "option",
                { attrs: { value: "https://gcmdservices.gsfc.nasa.gov" } },
                [_vm._v("GCMD")]
              ),
              _vm._v(" "),
              _c(
                "option",
                { attrs: { value: "http://www.eionet.europa.eu/gemet" } },
                [_vm._v("Gemet")]
              ),
              _vm._v(" "),
              _c(
                "option",
                { attrs: { value: "http://linked.earth/ontology" } },
                [_vm._v("Linked Earth")]
              ),
              _vm._v(" "),
              _c(
                "option",
                { attrs: { value: "https://w3id.org/ozcar-theia" } },
                [_vm._v("OZCAR-THEIA")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "trajectories-text" }, [
          _vm._v("Scientific Keywords:")
        ]),
        _vm._v(" "),
        _vm.getFacetClassification != null
          ? _c(
              "div",
              { staticStyle: { border: "1px solid #CCC" } },
              [
                _c("filter-by-keyword-component", {
                  staticStyle: {
                    resize: "vertical",
                    overflow: "scroll",
                    "min-height": "18px",
                    height: "197px"
                  },
                  attrs: {
                    keywordOntologies:
                      _vm.getFacetClassification.keywordOntologiesFacet,
                    facetElements: _vm.getFacetClassification.keywordsFacet,
                    mutationName: "UPDATE_FILTERS_KEYWORDS"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui segment",
        staticStyle: { margin: "5px", padding: "8px", "padding-top": "35px" }
      },
      [
        _c("div", { staticClass: "ui top attached label" }, [
          _vm._v("Settings")
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "trajectories-text" }, [
          _vm._v("Map Object Clustering:")
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            staticStyle: { "font-size": "11px" },
            on: {
              change: function($event) {
                return _vm.clusteringChanged($event)
              }
            }
          },
          [
            _c("option", { attrs: { value: "clustering_on" } }, [_vm._v("On")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "clustering_off" } }, [
              _vm._v("Off")
            ])
          ]
        ),
        _vm._v(" "),
        _c("br")
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "trajectories-banner" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: "assets/images/trajectories_banner.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "ui segment",
        staticStyle: { margin: "5px", padding: "8px" }
      },
      [
        _c("div", { staticClass: "ui top attached label" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("div", { staticStyle: { height: "20px" } }, [
          _c(
            "div",
            {
              staticClass: "trajectories-text",
              staticStyle: { float: "left" }
            },
            [_vm._v("Min Year:")]
          ),
          _vm._v(" "),
          _c("input", {
            staticStyle: {
              float: "left",
              width: "100px",
              "margin-left": "5px"
            },
            attrs: { type: "text", id: "minDate", value: "" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "trajectories-text",
              staticStyle: { float: "left", "margin-left": "15px" }
            },
            [_vm._v("Max Year:")]
          ),
          _vm._v(" "),
          _c("input", {
            staticStyle: {
              float: "left",
              width: "100px",
              "margin-left": "5px"
            },
            attrs: { type: "text", id: "maxDate", value: "" }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }